const state = () => ({});

/* eslint-disable no-shadow, arrow-body-style */
const getters = {
  getWidgets: (state) => state,
  getWidgetByID: (state) => (id) => {
    return state[`widget${id}`];
  },
};
/* eslint-enable */

const actions = {};

/* eslint-disable no-shadow, arrow-body-style, no-param-reassign */
const mutations = {
  RESET_WIDGETS_STATE: (s) => {
    const initial = state();

    Object.keys(initial).forEach((key) => {
      s[key] = initial[key];
    });
  },
};
/* eslint-enable */

export default {
  state,
  getters,
  actions,
  mutations,
};
